import styled, { css } from 'styled-components/macro';
import { ReactComponent as Search } from '../assets/icons/search.svg';
import { ReactComponent as X } from '../assets/icons/x.svg';

const viewOptionIconStyles = css`
  height: 1.7rem;
  margin: 0 5px;
  cursor: pointer;
  fill: ${props =>
    (props.styled || {}).active ? props.theme.brand : props.theme.dustyGray};
`;

const readOnly = css`
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const SearchIcon = styled(Search)`
  ${viewOptionIconStyles};
  position: absolute;
  height: 1.3rem;
  top: 4px;
  left: 0;
  padding: 0 5px;
  ${readOnly};
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: transparent;
  padding-bottom: 0.4rem;
  ${props =>
    !props.hideBorderBottom &&
    css`
      border-bottom: 1px solid ${props => props.theme.mercury};
    `}
  &:focus {
    border-bottom: 2px solid ${props => props.theme.blue};
    ${props =>
      props.hideBorderBottom &&
      css`
        border-bottom: unset;
      `}
  }
  padding-left: 30px;
  ::placeholder {
    color: ${props => props.theme.dustyGray};
    font-size: 1.3rem;
  }
  ${readOnly}
  cursor: pointer;
`;

export const SearchStaticDiv = styled.div`
  position: relative;
  > p {
    color: ${props => props.theme.dustyGray};
  }
  ${readOnly}

  ${props =>
    props.disabled &&
    css`
      input {
        cursor: not-allowed;
      }
    `}
`;

export const XIcon = styled(X)`
  position: absolute;
  width: 9px;
  height: 9px;
  right: 1rem;
  &&& {
    top: 3px;
  }
  cursor: pointer;
  fill: ${props => props.theme.black};
  &:hover {
    fill: black;
  }
  ${readOnly}
`;
